import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { DocumentDto, CreateDocument, UpdateDocument } from '#models';

@Injectable({ providedIn: 'root' })
export class DocumentService {
    private _http = inject(HttpClient);
    private _base = `${environment.apiBaseUrl}/v1`;

    getDocumentsByAsset(assetId: string): Observable<DocumentDto[]> {
        return this._http.get<DocumentDto[]>(`${this._base}/assets/${assetId}/documents`);
    }

    getDocumentsByProject(projectId: string): Observable<DocumentDto[]> {
        return this._http.get<DocumentDto[]>(`${this._base}/projects/${projectId}/documents`);
    }

    createDocumentForAsset(assetId: string, dto: CreateDocument): Observable<DocumentDto> {
        return this._http.post<DocumentDto>(`${this._base}/assets/${assetId}/documents`, dto);
    }

    createDocumentForProject(projectId: string, dto: CreateDocument): Observable<DocumentDto> {
        return this._http.post<DocumentDto>(`${this._base}/projects/${projectId}/documents`, dto);
    }

    updateDocument(assetId: string, documentId: string, dto: UpdateDocument): Observable<DocumentDto> {
        return this._http.put<DocumentDto>(`${this._base}/assets/${assetId}/documents/${documentId}`, dto);
    }

    deleteDocument(assetId: string, documentId: string): Observable<void> {
        return this._http.delete<void>(`${this._base}/assets/${assetId}/documents/${documentId}`);
    }
}
